import React from 'react'

const Button = ({name,onClick}) => {
  return (
    <button onClick={onClick} className='button-bg'>{name}</button>
  )
}

export default Button